import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { SubmitButton } from "../../components/Input";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";

const CustomPageForm = () => {
  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [description, setDescription] = useState("");
  const { id } = useParams(); // For editing existing page
  const navigate = useNavigate();

  // Fetch the page details if editing
  useEffect(() => {
    if (id) {
      fetchPage(id);
    }
  }, [id]);

  const fetchPage = async (id) => {
    try {
      const response = await fetch(`${API_URL}CustomePage/${id}`);
      const data = await response.json();
      if (data.success) {
        setTitle(data.data.title);
        setHeading(data.data.heading);
        setShortDesc(data.data.short_desc);
        setDescription(data.data.description);
      } else {
        showToast.error("Failed to fetch page details");
      }
    } catch (err) {
      console.error("Error fetching page details:", err);
      showToast.error("Failed to fetch page details");
    }
  };

  const handleEditorChange = (value) => {
    setDescription(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      title,
      heading,
      short_desc: shortDesc,
      description,
    };

    try {
      const token = localStorage.getItem("authToken");
      const method = id ? "PUT" : "POST";
      const url = id ? `${API_URL}CustomPage` : `${API_URL}CustomPage`;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success || 201 === response.status) {
        showToast.success(id ? "Page updated successfully" : "Page created successfully");
        navigate("/CustomPages");
      } else {
        showToast.success(result.message || "Failed to save the page");
      }
    } catch (err) {
      console.error("Error saving page:", err);
      showToast.error("Failed to save the page");
    }
  };

  return (
    <div className="page-container mt-5">
      <div className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit}>
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">
                {id ? "Edit Page" : "Add Page"}
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Title */}
                <div className="col-md-4">
                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>

                {/* Heading */}
                <div className="col-md-4">
                  <label>Heading</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Heading"
                    value={heading}
                    onChange={(e) => setHeading(e.target.value)}
                  />
                </div>

                {/* Short Description */}
                <div className="col-md-4">
                  <label>Short Description</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Short Description"
                    value={shortDesc}
                    onChange={(e) => setShortDesc(e.target.value)}
                  />
                </div>

                {/* Description with ReactQuill */}
                <div className="col-md-12 mt-3">
                  <label>Description</label>
                  <ReactQuill
                    value={description}
                    onChange={handleEditorChange}
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        ["link", "image"],
                        ["blockquote", "code-block"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                    style={{ height: "300px", marginBottom: "50px" }}
                  />
                </div>
              </div>

              <SubmitButton
                pageBack={`/CustomPages`}
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>
      </div>
      {/* Scroll to top button */}
      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default CustomPageForm;
